import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotificationsCount } from '@app/store/slices/notificationsSlice';

const POLL_INTERVAL_MS = 5000;

export function useNotificationsPolling() {
  const dispatch = useDispatch();
  const isInitialized = useSelector((state) => state.user.isInitialized);
  const userId = useSelector((state) => state.user.user?.id);

  useEffect(() => {
    if (!isInitialized || !userId) return;

    let isActive = true;
    let timeoutId = null;
    let request = null;

    const tick = async () => {
      timeoutId = null;
      request = dispatch(fetchNotificationsCount());
      await request;
      request = null;

      if (isActive && !document.hidden) {
        timeoutId = setTimeout(tick, POLL_INTERVAL_MS);
      }
    };

    const stop = () => {
      clearTimeout(timeoutId);
      timeoutId = null;
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        stop();
      } else if (!timeoutId && !request) {
        tick();
      }
    };

    if (!document.hidden) {
      tick();
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      isActive = false;
      stop();
      request?.abort();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [dispatch, isInitialized, userId]);
}
